export const CONTENT_UPDATE = 'CONTENT_UPDATE'
export const CONTENT_REVERT = 'CONTENT_REVERT'
export const LOCATION_POP = 'LOCATION_POP'

export const SIMILAR_TEMPLATES_DONE = 'SIMILAR_TEMPLATES_DONE'
export const SIMILAR_TEMPLATES_RESET = 'SIMILAR_TEMPLATES_RESET'
export const SIMILAR_TEMPLATES_INJECT = 'SIMILAR_TEMPLATES_INJECT'
export const SIMILAR_TEMPLATES_START = 'SIMILAR_TEMPLATES_START'
export const SIMILAR_TEMPLATES_ERROR = 'SIMILAR_TEMPLATES_ERROR'

export const PAGE_SIZE_UPDATE = 'PAGE_SIZE_UPDATE'
export const PAGE_UPDATE = 'PAGE_UPDATE'
